import { LocalizationSerializer } from "@serializers/localization"

import { BaseHttpProvider } from "./base-http.provider"

import type { LanguageISO } from "./types"

export class GDPRProvider extends BaseHttpProvider {
  async find(locale: LanguageISO) {
    const response = await this.execute({
      uri: `/gdpr-page?_locale=${locale}`,
      method: "GET",
    })

    return {
      title: response?.title,
      content: response?.content,
      templates: response?.templates.map(LocalizationSerializer),
    }
  }
}
